import { useEffect, useState } from "react";

// Chakra imports
import {
    Box,
    Button, Flex, SimpleGrid, Text, useColorModeValue
} from "@chakra-ui/react";

// Custom components
import Card from "components/card/Card.js";
import NFT from "components/card/NFT";

// Assets
import { Link } from "@chakra-ui/react";
import { useGetAccountInfo } from "@multiversx/sdk-dapp/hooks/account";
import axios from "axios";
import { ASTRONAUTS } from "constants/Collection";
import { Ripple } from 'react-spinners-css';


export default function YourCard(props) {
    const textColor = useColorModeValue("secondaryGray.900", "white");
    const { address } = useGetAccountInfo();
    const [astronautsCollection, setAstronautsCollection] = useState();

    useEffect(async () => {
        const response = await axios.get(`https://api.elrond.com/accounts/${address}/nfts?size=3000&collection=${ASTRONAUTS}`)
            .catch(e => console.error(e));
        const data = response.data.filter(item => item.collection === ASTRONAUTS);
        setAstronautsCollection(data);
    }, [])

    return (
        <Card {...props} mt={{ lg: '0px', sm: '25px' }}>
            <Flex height={'100%'} justify='space-between' px='10px' pt='5px' mb='25px' align='center'>
                <Flex height={'100%'} direction='column' width={'100%'}>
                    <Flex
                        mb='20px'
                        justifyContent='start'
                        direction={{ base: "column", md: "row" }}
                        align={{ base: "start", md: "center" }}
                    >
                        <Text color={textColor} fontSize='2xl' fontWeight='700'>
                            In your wallet
                        </Text>
                    </Flex>
                    {astronautsCollection ?
                    <SimpleGrid className="in-your-wallet" overflowY={'scroll'} columns={{ base: 2, md: 4, xl: 2 }} gap='0px'>
                        {astronautsCollection?.map((nft) => {
                            return <NFT
                                key={nft.identifier}
                                nft={nft}
                                />
                        })}
                        </SimpleGrid> :
                        <Box gap='20px' display='flex' justifyContent='center' alignItems='center'>
                            <Ripple color='#efbc5e' />
                        </Box>
                    }
                    {astronautsCollection?.length === 0 && (
                        <Flex flexDirection={'column'}>
                            <Text mb={'10px'}>Oh 😕 Looks like you don't have any Astronauts in your wallet...</Text>
                            <Text mb={'20px'}>You can find Astronauts on the secondary market :</Text>
                            <Flex>
                                <Button className="btn-primary" mr={'15px'} bg={'linear-gradient(135deg, #efbc5e 0%, #e1871e 100%)'} to={'google.com'} width={'150px'}><Link href="https://deadrare.io/collection/ASTRONAUTS-22c98a" isExternal>DEADRARE</Link></Button>
                                <Button className="btn-primary" bg={'linear-gradient(135deg, #efbc5e 0%, #e1871e 100%)'} width={'150px'}><Link href="https://xoxno.com/collection/ASTRONAUTS-22c98a" isExternal>XOXNO</Link></Button>
                            </Flex>
                        </Flex>
                    )}
                </Flex>
            </Flex>
        </Card>
    );
}

